/**
 * Whether an analytics tab should say the tracker is not live yet, instead of
 * drawing a report of zeros. Only when every signal agrees: the site was never
 * verified, nothing arrived in the last 7 days, and this period is empty. An
 * unknown tracking status (no workspace record for the property) never claims
 * it, since a dormant site and a broken install look the same from zeros alone.
 */
export function isTrackingNotLive({
  trackingStatus,
  hasRecentViews,
  periodViews,
  periodVisitors,
}: {
  trackingStatus?: string | null
  hasRecentViews?: boolean
  periodViews: number
  periodVisitors: number
}): boolean {
  if (!trackingStatus || trackingStatus === 'verified') return false
  if (hasRecentViews) return false
  return periodViews === 0 && periodVisitors === 0
}
